var lengthDefault = process.env.NODE_ENV == "development1" ? randomInteger(4, 6) : randomInteger(12, 24);

export default class InterestingMoment {
    constructor(minLevel = 1, maxLevel = 9) {
        this.minLevel = minLevel;
        this.maxLevel = maxLevel;
    }
    
    get(frame) {
        if(frame.coordinates != null && frame.coordinates.ball != null && frame.coordinates.ball.x >= this.minLevel && frame.coordinates.ball.x <= this.maxLevel ) {
            if(frame.G != null)
                return [frame.num - lengthDefault, frame.num, frame.coordinates.ball.x]
            
            return [frame.num - lengthDefault, frame.num + 3, frame.coordinates.ball.x]
        }
    }
}

function randomInteger(min, max) {
    var rand = min - 0.5 + window.rand() * (max - min + 1)
    rand = Math.round(rand);
    return rand;
}


/** WEBPACK FOOTER **
 ** ./src/episods/all/interesting_moment.js
 **/